<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCardHeader class="p-1">
          <CRow>
            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

              <strong>تعطیلات رسمی</strong>
            </CCol>
            <CCol col="4" style="text-align: end">

              <CButton color="primary" @click="status_form=0,dialog_add_holiday = true">افزودن تعطیلی</CButton>

            </CCol>
          </CRow>
        </CCardHeader>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="8">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>انتخاب کامند</strong>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol>
                <date-picker
                    type="month"
                    label="ماه"
                    v-model="month"/>

              </CCol>
              <CCol>
                <date-picker
                    type="year"
                    label="سال"
                    v-model="year"/>

              </CCol>
              <CCol>
                <CButton
                    color="dark"
                    @click="get_data_detail()"
                    size="sm"
                >
                  <CIcon name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>
            <CDataTable
                :items="items"
                :fields="fields"
                :items-per-page="10"
                hover
                sorter
                striped
                border
                column-filter
                pagination
            >
              <template #row="{item,index}">
                <td style="text-align: center">
                  <p >{{ index + 1 }}</p>
                </td>
              </template>
              <template #date="{item}">
                <td style="text-align: center">
                  <p >{{get_date(item.date)}}</p>
                </td>
              </template>

              <template #operation="{item}">
                <td>
                  <!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
                  <!--                                   name="cilApplications"/>-->

                  <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>

                                      <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                </td>
              </template>


            </CDataTable>

          </CCardBody>
        </CCard>
      </CCol>

    </CRow>

    <CModal :title="status_form==0? 'افزودن تعطیلی' : 'ویرایش تعطیلی'" :show.sync="dialog_add_holiday">
      <CInput v-model="title"
              label="عنوان"
      />
      <date-picker
          v-model="date"
          display-format="jYYYY/jMM/jDD"
          format="YYYY-MM-DD"
          label="تاریخ تعطیلی"
      />
      <template #footer>
        <CButton @click="dialog_add_holiday = false,send_data()" color="dark">{{ $t('buttons.ok') }}</CButton>
        <CButton @click="dialog_add_holiday = false" color="dark">{{ $t('buttons.cancel') }}</CButton>

      </template>
    </CModal>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

import Vue from "vue";

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      dialog_add_holiday: false,
      confirm_delete_name: "confirm_delete_holiday" + new Date().getTime() + "_" + this.$vnode.tag,
      title: '',
      date: '',
      month: '',
      year: '',
      file: null,
      export_file_name: '',
      export_modal: false,
      json_data: [],
      items: [],
      fields: [
        {key: 'row', label: 'ردیف', _style: 'width:10%'},
        {key: 'title', label: "عنوان", _style: 'width:20%'},
        {key: 'date', label: "تاریخ", _style: 'width:20%;'},
        {key: 'operation', label: "عملیات", _style: 'width:20%;'},

      ],
      status_form: 0,
      selected_file_type: 0,
      personnel_list: [],
      settings: [],
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.month = moment().subtract(1, 'month').format('jMM')
    this.year = moment().format('jYYYY')
    this.get_data_detail()
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_holiday();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {},
  methods: {

edit_item(item){
  this.status_form=item.id
  this.title=item.title
  this.date=item.date
  this.dialog_add_holiday=true
},
    send_data() {
      var self = this;
      const formData = new FormData();
      var url = "add_holiday";
      var its = [];
      if (this.status_form != 0) {
        url = "edit_holiday"
        formData.append("id", this.status_form);

      }

      // console.log("items",its);
      formData.append("title", this.title);
      formData.append("date", this.date);
      axios.post(url, formData, {}).then(function (response) {

        // var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);
        self.items = [];
        self.get_data_detail();
        // if (content_data.statusCode == 0) {
        //
        //
        // } else {
        //   self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        //
        // }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_data_detail() {

      let self = this;
      const formData = new FormData();
      let url = "get_holidays";
      formData.append('year', this.year);
      formData.append('month', this.month);

      axios.post(url, formData, {}).then((res) => {

        self.items = res.data

      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_holiday() {

      let self = this;
      const formData = new FormData();
      let url = "delete_holiday";
      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.get_data_detail()

      }).catch(function (error) {
        console.log(error);
      });

    },
  }
}

</script>
<style>
.bg-yellow {
  background: #ffee3f;
}
</style>
